import React, { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { HiOutlineArrowRight, HiOutlineChevronDown, HiOutlineQuestionMarkCircle } from "react-icons/hi";
import { Link } from "react-router-dom";
import { scrollTop } from "../../utils/window";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";

const publicUrl = process.env.PUBLIC_URL || "";

function FaqAccordion({ title, isOpen, onToggle, index, children }) {
  return (
    <article className={`pi-info__accordion-item ${isOpen ? "is-open" : ""}`}>
      <button
        type="button"
        className="pi-info__accordion-trigger"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="pi-info__accordion-num">{String(index + 1).padStart(2, "0")}</span>
        <span className="pi-info__accordion-title">{title}</span>
        <HiOutlineChevronDown className="pi-info__accordion-chevron" aria-hidden />
      </button>
      <Collapse in={isOpen}>
        <div className="pi-info__accordion-panel">{children}</div>
      </Collapse>
    </article>
  );
}

export default function FAQs() {
  const { feedback } = useContext(FeedbackContext);
  const FAQs = feedback.FAQs;

  const [activeTab, setActiveTab] = useState(0);
  const [expandedA, setExpandedA] = useState(false);
  const [expandedB, setExpandedB] = useState(false);

  useEffect(() => {
    scrollTop();
  }, []);

  const categories = [
    {
      label: FAQs.box1_desc,
      items: [
        {
          title: FAQs.dropdown1_desc,
          isOpen: expandedA,
          onToggle: () => setExpandedA(!expandedA),
          content: (
            <>
              <span>{FAQs.dropdown1_p1}</span>
              <span>{FAQs.dropdown1_p2}</span>
            </>
          ),
        },
        {
          title: FAQs.dropdown2_desc,
          isOpen: expandedB,
          onToggle: () => setExpandedB(!expandedB),
          content: (
            <>
              <span>{FAQs.dropdown2_p3}</span>
              <span>{FAQs.dropdown2_p4}</span>
            </>
          ),
        },
      ],
    },
    {
      label: FAQs.box2_desc,
      items: [
        {
          title: FAQs.box2_dropdown_desc,
          isOpen: expandedA,
          onToggle: () => setExpandedA(!expandedA),
          content: (
            <>
              <p>{FAQs.dropdown1_p5}</p>
              <p>{FAQs.dropdown1_p6}</p>
              <p>{FAQs.dropdown1_p7}</p>
            </>
          ),
        },
      ],
    },
    {
      label: FAQs.box3_text,
      items: [
        {
          title: FAQs.box3_dropdown_desc,
          isOpen: expandedA,
          onToggle: () => setExpandedA(!expandedA),
          content: (
            <>
              <p>{FAQs.dropdown1_p5}</p>
              <p>{FAQs.dropdown1_p6}</p>
              <p>{FAQs.dropdown1_p7}</p>
            </>
          ),
        },
      ],
    },
  ];

  const activeCategory = categories[activeTab];

  return (
    <div className="pi-info pi-faq">
      <header className="pi-inner-hero pi-info__hero">
        <div className="pi-inner-hero__media" aria-hidden="true">
          <img
            className="pi-inner-hero__media-img pi-info__hero-img"
            src={`${publicUrl}/images/info-faq-hero.jpg`}
            alt=""
          />
          <span className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden="true">
          <span className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <span className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <span className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy pi-info__reveal pi-info__reveal--1">
            <p className="pi-label pi-inner-hero__label">Help center</p>
            <h1 className="pi-inner-hero__title">{FAQs.frequent_text}</h1>
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden />
      </header>

      <div className="pi-info__body">
        <div className="pi-info__body-fx" aria-hidden="true">
          <span className="pi-info__body-glow pi-info__body-glow--a" />
          <span className="pi-info__body-glow pi-info__body-glow--b" />
        </div>
        <div className="pi-info__inner">
          <div className="pi-info__layout">
            <div className="pi-info__main pi-info__reveal pi-info__reveal--2">
              <div className="pi-faq__shell">
                <nav className="pi-faq__nav" aria-label="FAQ categories">
                  {categories.map((category, index) => (
                    <button
                      key={category.label}
                      type="button"
                      className={`pi-faq__nav-btn ${activeTab === index ? "is-active" : ""}`}
                      onClick={() => setActiveTab(index)}
                      aria-current={activeTab === index ? "true" : undefined}
                    >
                      <span className="pi-faq__nav-num">{String(index + 1).padStart(2, "0")}</span>
                      {category.label}
                    </button>
                  ))}
                </nav>

                <div className="pi-faq__panel">
                  <div className="pi-info__accordion">
                    {activeCategory.items.map((item, index) => (
                      <FaqAccordion
                        key={item.title}
                        title={item.title}
                        isOpen={item.isOpen}
                        onToggle={item.onToggle}
                        index={index}
                      >
                        {item.content}
                      </FaqAccordion>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <aside className="pi-info__aside pi-info__reveal pi-info__reveal--3">
              <div className="pi-info__art">
                <span className="pi-info__art-grid" aria-hidden />
                <span className="pi-info__art-icon" aria-hidden>
                  <HiOutlineQuestionMarkCircle size={24} />
                </span>
                <h3>Still need help?</h3>
                <p>Browse answers by category or reach our team for personalised support.</p>
                <div className="pi-info__art-chips">
                  <span className="pi-info__art-chip">Quick answers</span>
                  <span className="pi-info__art-chip">24/7 support</span>
                </div>
                <Link to="/contactus" className="pi-info__cta-link">
                  Contact us
                  <HiOutlineArrowRight size={16} aria-hidden />
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}
